// 关系及佣金路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/relationship',
  component: Layout,
  children: [
    {
      path: 'goodsCommission',
      component: () => import('@/view/relationship/goodsCommission'),
      name: '商品佣金设置'
    }
  ]
}
